import React, { useState } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { EditOutlined } from '@ant-design/icons';

let formRef = React.createRef();

function AddUser(props) {
    
    const [ loading, setLoading ] = useState(false);

    const finishHandler = async (values) => {
        setLoading(true);
        await props.onClick(values);
        setLoading(false);
        formRef.current.resetFields();
    }

    return (
        <>
            <Form
                name="usr"
                onFinish={finishHandler}
                onFinishFailed={() => {} }
                ref={formRef}
            >
                <Row
                    gutter={[10,10]}
                    justify="start"
                >
                    <Col span={1} offset={2} />
                    <Col span={8}>
                        <Form.Item
                            name="regid"
                            hidden="true"
                            initialValue="ak6"
                        >
                        </Form.Item>
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                required: true,
                                message: "Bitte eine E-Mail-Adresse eingeben!"
                                }
                            ]}
                        >
                            <Input placeholder="E-Mail-Adresse" />
                        </Form.Item>          
                    </Col>
                    <Col span={7}>
                        <Form.Item
                            name="association"
                            rules={[
                                {
                                required: true,
                                message: "Bitte einen Verein eingeben!"
                                }
                            ]}
                        >
                            <Input placeholder="Verein" />
                        </Form.Item>          
                    </Col>
                    <Col span={4}>
                        <Button 
                            type="primary"
                            htmlType="submit"
                            icon={<EditOutlined />}
                            loading={loading}
                        >
                            Hinzufügen
                        </Button>
                    </Col>
                    <Col span={2} />
                </Row>
            </Form>
        </>
    )
}

export default AddUser;